import { render, staticRenderFns } from "./userRoleView.vue?vue&type=template&id=7836282d&"
import script from "./userRoleView.vue?vue&type=script&lang=js&"
export * from "./userRoleView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports